// eslint-disable-next-line no-use-before-define
import React from 'react';
import { isFactorTv } from 'renative';
import { I18nManager } from 'react-native';
import { Text, View, Interactable, ThemeIcon } from '@24i/nxg-sdk-quarks';
import { useTheme, getFont } from '@24i/nxg-sdk-higgs';
import { TopBarPrimaryProps } from '../types';
import { overridable } from '../../../../context/ComponentOverrides';
import getTopBarPrimaryStyles from '../styles';

import BackButton from '../../../buttons/BackButton';

const TopBarPrimary = (props: TopBarPrimaryProps) => {
    const {
        styles: getStyles = getTopBarPrimaryStyles,
        title,
        previous,
        onBack,
        onClose,
        additionalContainerStyles,
    } = props;
    const { theme } = useTheme();

    const hasActionButtons = !!(previous || onClose) && !isFactorTv;

    const styles = getStyles(theme, hasActionButtons);

    return (
        <View style={[styles.container, additionalContainerStyles]}>
            {previous && !isFactorTv && (
                <BackButton
                    iconName={`onPrimary-back${I18nManager.isRTL ? '_rtl' : ''}`}
                    iconSize={getFont(theme, 'h2').fontSize * 0.8}
                    onPress={onBack}
                    additionalContainerStyles={styles.backButtonContainer}
                />
            )}
            <View style={styles.textContainer}>
                <Text style={styles.text}>{title}</Text>
            </View>
            {onClose && !isFactorTv && (
                <Interactable onPress={onClose} style={styles.closeButtonContainer}>
                    <ThemeIcon
                        iconName="onPrimary-close"
                        size={getFont(theme, 'h2').fontSize * 0.8}
                    />
                </Interactable>
            )}
        </View>
    );
};

export default overridable(TopBarPrimary, 'TopBarPrimary');
